import * as S from "./styles";

import React, { HtmlHTMLAttributes } from 'react';

interface InputProps extends HtmlHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  type: string;
  placeholder?: string;
  label?: string;
  defaultValue?: any;
  value?: string;
  required: boolean;
  containerClassName?: string;
  inputClassname?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  maxLength?: number;
  error?: any;
  apiErrorName?: string;
  handleApiErrorRemove?: () => void;
  dataCy?: string;
  fullfillHighlight?: boolean;
}

function Input({
  id,
  name,
  type,
  placeholder,
  label,
  required,
  onChange,
  defaultValue = undefined,
  onPaste,
  value,
  inputClassname = "",
  containerClassName = "",
  maxLength,
  error,
  disabled,
  onBlur,
  dataCy,
  apiErrorName,
  handleApiErrorRemove,
  fullfillHighlight = false,
  ...props
}: InputProps) {
  const [fullfilled, setFullfilled] = React.useState<boolean>(false);

  return (
    <S.Container className={containerClassName}>
      {label && (
        <label htmlFor={id}>
          {label}
          {required && <S.RequiredHint> *</S.RequiredHint>}
        </label>
      )}

      <S.StyledInput
        id={id}
        data-cy={dataCy}
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        value={value}
        onPaste={onPaste}
        className={inputClassname}
        defaultValue={defaultValue}
        fullfiled={fullfilled}
        onChange={onChange}
        disabled={disabled}
        error={error !== undefined}
        maxLength={maxLength}
        onBlur={(event) => {
          if (event.target.value && fullfillHighlight) {
            setFullfilled(true);
          }

          onBlur && onBlur(event);
        }}
        onFocus={() =>
          apiErrorName && handleApiErrorRemove && handleApiErrorRemove()
        }
        {...props}
      />
      {error && <small>{error}</small>}
    </S.Container>
  );
}

export default Input;
